module.exports = __webpack_public_path__ + "static/img/wexincode.23ff836b.jpg";